module.exports = __webpack_public_path__ + "img/IT0000175439195.aa7c9c29.png";